<template>
  <div ref="contact">
    <h4 v-if="contactTitle" class="mb-4">{{contactTitle}}</h4>
    <v-form
      v-if="contact"
      v-model="valid"
      ref="contactForm"
      lazy-validation
    >
      <v-checkbox v-if="showResCheckBox"
                  label="This is a Residential Address"
                  v-model="contactData.residential"
                  validate-on-blur
      />
      <v-checkbox v-if="showUseShipping"
                  label="Use Shipping Information for Billing"
                  v-model="contactData.copyAddress"
                  @change="$emit('copy-address', $event)"
      />
      <v-text-field label="First Name"
                    v-model="contactData.first_name"
                    :rules="requiredRules"
                    validate-on-blur
      />
      <v-text-field label="Last Name"
                    v-model="contactData.last_name"
                    :rules="requiredRules"
                    validate-on-blur
      />
      <v-text-field label="Company"
                    v-model="contactData.company"
                    validate-on-blur
      />
      <v-text-field label="Address 1"
                    v-model="contactData.street1"
                    :rules="requiredRules"
                    validate-on-blur
      />
      <v-text-field label="Address 2"
                    v-model="contactData.street2"
                    validate-on-blur
      />
      <v-text-field label="City"
                    v-model="contactData.city"
                    :rules="requiredRules"
                    validate-on-blur
      />
      <v-autocomplete label="State/Province"
                      placeholder="Select if United States or Canada"
                      v-model="contactData.state"
                      :items="states"
                      item-value="abbr"
                      item-text="name"
                      dense
                      clearable
                      validate-on-blur
      />
      <v-text-field label="ZIP/Postal Code"
                    v-model="contactData.zip"
                    :rules="requiredRules"
                    validate-on-blur
      />
      <v-autocomplete label="Country"
                      v-model="contactData.country"
                      :items="countries"
                      item-value="abbr"
                      item-text="name"
                      :rules="requiredRules"
                      dense
                      validate-on-blur
      />
      <v-text-field label="Email Address"
                    v-model="contactData.email"
                    :rules="emailRules"
                    validate-on-blur
      />
      <v-text-field label="Phone"
                    v-model="contactData.phone"
                    :rules="phoneRules"
                    validate-on-blur
      />
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    contact: Object,
    contactTitle: String,
    showResCheckBox: Boolean,
    showUseShipping: Boolean
  },

  data () {
    return {
      valid: false,
      contactData: {},
      requiredRules: [
        v => !!v || 'Cannot be blank'
      ],
      phoneRules: [
        v => !!v || 'Phone is required',
        v => v && v.length > 5 || 'Phone must be valid'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => v && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ]
    }
  },

  computed: {
    states () {
      return this.$store.state.states
    },

    countries () {
      return this.$store.state.countries
    },

    customers () {
      return this.$store.state.customers
    }
  },

  watch: {
    contactData: {
      handler (val) {
        this.updateContact()
      },
      deep: true
    }
  },

  methods: {
    isValid () {
      return this.$refs.contactForm.validate()
    },

    updateContact () {
      if (!this.isValid) {
        this.$toast.error('You have missing or invalid data above.')
        return
      }

      this.$emit('update-contact', this.contactData)
    }
  },

  beforeMount () {
    this.$store.dispatch('loadCustomers')
    this.contactData = this.contact
  }
}
</script>



// WEBPACK FOOTER //
// contact-input.vue?49c4f1b6